var _style, _g, _circle, _path, _path2, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoNey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30.6 30.5",
    style: {
      enableBackground: "new 0 0 30.6 30.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.345;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#CD68ED;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#a_2_);}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\r\n\t.st5{fill:#8605A5;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)",
    className: "st0"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    className: "st1",
    cx: 15,
    cy: 14,
    r: 15
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.1573,
    y1: -3.9768,
    x2: 0.8273,
    y2: -3.0446,
    gradientTransform: "matrix(30 0 0 30 0 119)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F0F4F7",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8F8F9"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "a_1_",
    className: "st2",
    cx: 15,
    cy: 14,
    r: 15
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: -4.1333,
    x2: 0,
    y2: -4.1333,
    gradientTransform: "matrix(30 0 0 30 0 120)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F0F4F7",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8F8F9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0-4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: -4.1333,
    x2: 0,
    y2: -4.1333,
    gradientTransform: "matrix(30 0 0 30 0 120)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F0F4F7",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8F8F9"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M0-4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M5.4,13.6l-1.2,0.8v-1.7L7,11v9H5.4V13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M8.2,14.1c0-2,1.4-3.1,3-3.1s3,1,3,3.1v3.1c0,2-1.4,3.1-3,3.1s-3-1-3-3.1V14.1z M9.9,17.2c0,1,0.7,1.4,1.3,1.4 c0.7,0,1.3-0.4,1.3-1.4V14c0-1-0.7-1.4-1.3-1.4c-0.7,0-1.3,0.4-1.3,1.4V17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M14.9,14.1c0-2,1.4-3.1,3-3.1s3,1,3,3.1v3.1c0,2-1.4,3.1-3,3.1s-3-1-3-3.1V14.1z M16.6,17.2 c0,1,0.7,1.4,1.3,1.4c0.7,0,1.3-0.4,1.3-1.4V14c0-1-0.7-1.4-1.3-1.4c-0.7,0-1.3,0.4-1.3,1.4V17.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.9,13.7c-1.5,0-1.5-2.2,0-2.2C24.4,11.5,24.4,13.7,22.9,13.7z M26.4,11.6l-3.3,5h-1l3.3-5H26.4z M22.9,13.1 c0.6,0,0.6-0.9,0-0.9C22.3,12.1,22.3,13.1,22.9,13.1z M25.6,16.6c-1.5,0-1.5-2.2,0-2.2S27.1,16.6,25.6,16.6z M25.6,16 c0.6,0,0.6-0.9,0-0.9S25,16,25.6,16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoNey);
export default __webpack_public_path__ + "static/media/mo-ney.bb8b4062ccf252a1a4fd09beead88550.svg";
export { ForwardRef as ReactComponent };